import { UntypedFormControl, Validators } from '@angular/forms';
import { ValidatorsService } from './Core/Abstract/validators/validators.service';
import {
  AlphaNumericValidator, AlphaNumericAndSpecialCharsValidator, dateFutureValidator,
  currencyValidator, EmailValidator, NumericValidator, signedCurrencyValidator,
  integerValidator
} from './Core/Abstract/validators/validators';
import { TranslateService } from '@ngx-translate/core';
export function registerValidators( translate: TranslateService,validatorsService: ValidatorsService) {

  return {
    validationMessages: [
      {
        name: 'required',
        message() {
          translate.getDefaultLang
          return translate.stream('GENERIC.REQUIRED');
        },
      },
      {
        name: 'alphaNumeric',
        message() {
          return translate.stream('GENERIC.ALPHANUMERIC');
        },
      },
      {
        name: 'integer',
        message() {
          return 'Is Required integer';
        },
      },
      {
        name: 'numeric',
        message() {
          return translate.stream('GENERIC.NUMERIC');
        },
      },
      {
        name: 'alphanumericandspecialchars',
        message() {
          return translate.stream('GENERIC.ALPHANUMERICANDSPECIALCHARS');
        },
      },
      {
        name: 'minLength',
        message(err, field) {
          const minLengthPrefix = translate.instant('GENERIC.MINLENGTHPREFIX');
          const minLengthSuffix = translate.instant('GENERIC.MINLENGTHSUFFIX');
          return `${minLengthPrefix} ${field.templateOptions.minLength} ${minLengthSuffix}`;
        },
      },
      {
        name: 'min',
        message(err, field) {
          const minPrefix = translate.instant('GENERIC.MINPREFIX');
          const minSuffix = translate.instant('GENERIC.MINSUFFIX');
          const intBearer = translate.instant('GENERIC.INTERESTBEARERSUM');
          if(field.key == 'buyerDiscCharge' || field.key == 'supplierDiscCharge'){
            return `${intBearer}`;
          }else{
            return `${minPrefix} ${field.templateOptions.min} ${minSuffix}`;
          }
        },
      },
      {
        name: 'max',
        message(err, field) {
          const maxPrefix = translate.instant('GENERIC.MAXPREFIX');
          const maxSuffix = translate.instant('GENERIC.MAXSUFFIX');
          const intBearer = translate.instant('GENERIC.INTERESTBEARERSUM');
          if(field.key == 'buyerDiscCharge' || field.key == 'supplierDiscCharge'){
            return `${intBearer}`;
          }else{
            return `${maxPrefix} ${field.templateOptions.max} ${maxSuffix}`;
          }
        },
      }
    ],
    validators: [
      { name: 'requiredTrue', validation: Validators.requiredTrue },
      { name: 'alphaNumeric', validation: AlphaNumericValidator },
      { name: 'alphanumericandspecialchars', validation: AlphaNumericAndSpecialCharsValidator },
      { name: 'numeric', validation: NumericValidator },
      { name: 'email', validation: EmailValidator },
      { name: 'date-future', validation: dateFutureValidator },
      { name: 'currency', validation: currencyValidator },
      { name: 'signedCurrency', validation: signedCurrencyValidator },
      { name: 'integer', validation: integerValidator }
    ]
  };
}